<!-- 模块-单个卡 -->
<template>
  <van-row class="card_template" :style="{ 'background-image': 'url(' + (bg_img) + ')'}">

    <van-col :span="12">
      <div class="type_name">{{data.type_name}}</div>
      <div class="type_en">{{data.type_en}}</div>
    </van-col>
    <van-col :span="12" style="text-align: right; margin-top: 2px;">
      <span>No.</span>
      <span style="margin-right: 15px; font-size: 22px;">{{data.card_no}}</span>
    </van-col>
    <van-col :span="24"><div class="default" :style="{background: if_default}"></div></van-col>

    <van-col :span="8" style="font-size: 14px;">
      <div class="limit">可加油品: {{set_limit_oil()}}</div>
      <div class="limit">今日可用: {{set_limit_num()}}</div>
    </van-col>
    <van-col :span="7" style="text-align: right;">
      <div style="font-size: 14px;">积分</div>
      <div class="number">{{data.inte}}</div>
    </van-col>
    <van-col :span="9" style="text-align: right;">
      <div style="font-size: 14px; margin-right: 15px">余额</div>
      <div class="number" style="margin-right: 15px">{{data.money}}</div>
    </van-col>

  </van-row>
</template>

<style lang="scss" scoped>
  .card_template {
    background-size: 100% 100%;
    border-radius: 10px;
    height: 140px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    color: #FFF;
    margin-bottom: 10px;
    padding-top: 10px;

    .type_name {
      font-size: 16px;
      line-height: 22px;
    }

    .type_en {
      font-size: 12px;
    }

    .type_name, .type_en {
      margin-left: 15px;
    }

    .default {
      width: 100%;
      height: 3px;
      margin-top: 5px;
      margin-bottom: 25px;
    }

    .limit {
      margin-left: 15px;
    }

    .number {
      font-size: 22px;
    }
  }
</style>

<script>
export default {
  name: 'card_template',
  props: ['data'],
  data () {
    return {
      bg_img: '',
      if_default: '#FFF'
    }
  },

  mounted () {
    this.set_style()
  },

  methods: {
    // 计算背景样式
    set_style () {
      switch (this.data.type) {
        case 151:
          this.bg_img = require('@/assets/oilcard_bg.png')
          break

        case 152:
          this.bg_img = require('@/assets/discountcard_bg.png')
          break

        case 101:
          this.bg_img = require('@/assets/Generalledgercard_bg.png')
          break

        case 102:
          this.bg_img = require('@/assets/rechargecard_bg.png')
          break

        case 104:
          this.bg_img = require('@/assets/billingcard_bg.png')
          break
      }

      if (this.data.default) {
        this.if_default = '#F56C6C'
      }
    },

    // 计算可用油品
    set_limit_oil () {
      // 判断卡性质
      if (this.data.chip_id === null) {
        // 虚拟卡
        return parseInt(this.data.oil_kind) === 1 ? '汽油' : '柴油'
      } else {
        // 实体卡
        return this.data.limit_oil_name !== '' ? this.data.limit_oil_name : '全部'
      }
    },

    // 计算今日可用
    set_limit_num () {
      if (this.data.limit_num < 0) {
        return '不限'
      } else if (this.data.limit_num > 0) {
        return this.data.limit_num + '次'
      } else {
        return '不可用'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/card_template.vue